import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import './AboutMe.css';

const AboutMe = () => {
  const skillsData = [
    {
      title: "Strategic Vision & Execution",
      description: "I bridge the gap between high-level strategy and tactical implementation, ensuring that every project delivers measurable business value.",
      points: [
        "Strategic planning and roadmap development",
        "Cross-functional team leadership and coordination",
        "Stakeholder management and executive communication"
      ]
    },
    {
      title: "Technical Product Management",
      description: "With hands-on technical experience, I speak both business and engineering languages fluently, enabling seamless collaboration across teams.",
      points: [
        "Technical requirements gathering and documentation",
        "API design and system architecture consultation",
        "Agile development methodologies and sprint planning"
      ]
    },
    {
      title: "Data-Driven Decision Making",
      description: "I leverage analytics and user research to inform product decisions, ensuring we build solutions that truly meet user needs and business objectives.",
      points: [
        "User research and behavioral analysis",
        "A/B testing and conversion optimization",
        "KPI tracking and performance measurement"
      ]
    },
    {
      title: "Innovation & Problem Solving",
      description: "I thrive on complex challenges, bringing creative solutions that balance user experience, technical feasibility, and business impact.",
      points: [
        "Creative problem-solving and solution design",
        "Competitive analysis and market research",
        "Innovation workshops and ideation facilitation"
      ]
    }
  ];

  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <div className="about-content">
          {/* Left Column - Image with Badge and Header */}
          <div className="about-image">
            <div className="about-header-sticky">
              <div className="about-label">About Me</div>
              <h2 className="about-title">From Vision to Execution</h2>
            </div>
            {/* Portrait Image */}
            <img 
              src="/images/logo/portrait.jpg" 
              alt="Lucas Xing Portrait" 
              className="portrait-image"
            />
            <div className="image-placeholder"></div>
          </div>

          {/* Right Column - Simple Skills List */}
          <div className="about-text">
            <div className="skills-list">
              {skillsData.map((skill, index) => (
                <div key={index} className="skill-item">
                  <h3 className="skill-title">{skill.title}</h3>
                  <p className="skill-description">{skill.description}</p>
                  <div className="skill-points">
                    {skill.points.map((point, pointIndex) => (
                      <div key={pointIndex} className="skill-point">
                        <CheckOutlined className="point-icon" />
                        <span className="point-text">{point}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
